import { addRoutes } from '../../../core-jsapi-v5/js/navigator/routes';
import type {
	GoToFn,
	NavigatorContext,
	NavigatorRoute,
} from '../../../core-jsapi-v5/js/navigator/types';
import { hasContext, appendQueryParam, enableApi } from '../../../core-jsapi-v5/js/navigator/utils';

export const registerJiraRoutes = () => {
	const routes: NavigatorRoute = {
		filters: '/secure/ManageFilters.jspa',
		projects: '/secure/BrowseProjects.jspa',
		boards: '/secure/ManageRapidViews.jspa',
		dashboards: '/secure/ConfigurePortalPages!default.jspa',
		dashboard: '/secure/Dashboard.jspa?selectPageId={dashboardId}',
		issue: '/browse/{issueKey}',
		userprofile: (context: NavigatorContext, callback: GoToFn) => {
			// Use the account id if it exists, otherwise use the username if it exists
			const profileBaseUrl = '/secure/admin/user/ViewProfile.jspa';
			let url;

			if (hasContext(context, 'userAccountId')) {
				// @ts-expect-error: TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
				url = appendQueryParam(profileBaseUrl, 'accountId', context.userAccountId);
			} else if (hasContext(context, 'username')) {
				// @ts-expect-error: TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
				url = appendQueryParam(profileBaseUrl, 'username', context.username);
			} else {
				url = `${profileBaseUrl}?name=`;
			}

			callback(url);
		},
		projectadminsummary: '/plugins/servlet/project-config/{projectKey}/summary',
		projectadmintabpanel:
			'/plugins/servlet/ac/{addonKey}/{adminPageKey}?project.key={projectKey}&project.id={projectId}',
	};

	addRoutes(routes);
	enableApi();
};
